import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children, allowedEmails = [] }) => {
  const { accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  // Wait until MSAL finishes loading tokens / processing redirect
  if (inProgress === "startup" || inProgress === "login") {
    return <div>Loading authentication...</div>; // or a spinner
  }

  if (!isAuthenticated || accounts.length === 0) {
    return <Navigate to="/login" replace />;
  }

  const userEmail = accounts[0].username.toLowerCase();

  if (allowedEmails.length > 0 && !allowedEmails.includes(userEmail)) {
    return (
      <div style={{ padding: 40, color: "red" }}>
        <h3>Access Denied</h3>
        <p>You are not authorized to view this page.</p>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
